import React, { useEffect, useState } from "react";
import DateRangeFilter from "../../common/DateRangeFilter";
import { Nav, Tab } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import { BackIcon, CloseIcon } from "../../../assets/Icons";
import MachineChart from "../../Charts/MachineDistribution";
import { useSelector } from "react-redux";
import { getInitials } from "../../../utils/util";
import Skeleton from "react-loading-skeleton";
import ResponseChart from "../../Charts/ResponseChart";
import axios from "axios";
import NegativeResponses from "../../NegativeResponses";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../../apiClient/index";
import GroupWiseReport from "../../GroupWiseReport";
import {
  DASHBOARD_SITE_STATS,
  FETCH_REGION_WISE_SCORE,
  FETCH_SITE_NEGATIVE_POSTIVE_STATS,
  FETCH_SUB_SITE_WITH_GROUPID,
  USER_WISE_INSPECTION_REPORT,
} from "../../../apiClient/endpoints";
import BarChart from "../../Charts/BarChart";
import GroupList from "../../GroupList";
import SiteWiseInspectionReport from "./SiteWiseInspectionStats";
import Filter from "./Filter";

const Dashboard = () => {
  const userData = useSelector((state) => state.userSlice);
  const navigate = useNavigate();
  const { groupId } = useParams();
  const configData = useSelector((state) => state.configSlice);
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [regionResponseStats, setRegionResponseStats] = useState([]);
  const [options, setOptions] = useState([]);
  const [machineId, setMachineId] = useState([]);
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [groupInfo, setGroupInfo] = useState(null);
  const [dates, setDates] = useState({ start: null, end: null });
  const [list, setList] = useState([]);
  // ____________________________________
  const [siteStats, setSiteStats] = useState({});
  const [userWiseInspectionData, setUserWiseInspectionData] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [inspectionDataLoading, setInspectionDataLoading] = useState(!true);
  const [resetStateFlag, setResetStateFlag] = useState(false);
  const filterOptions = getFilters(options);

  const fetchGroupDetail = async () => {
    setGroupInfo(null);
    const res = await apiClient.get(`${configData.config.UNO_URL}/api/user/group/details/${groupId}`, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });
    res ? setGroupInfo(res) : setGroupInfo({});
  };

  const fetchNegativeResponses = async () => {
    try {
      const { data } = await axios.post(
        `${configData.config.API_URL}/api/dashboard/report/negative/responses/${groupId}`,
        {
          machineIds: machineId.map((item) => item.code),
          dates: {
            start: dates.start ? dates.start.toISOString() : null,
            end: dates.start ? dates.end.toISOString() : null,
          },
          isSite: true,
          filters: {
            site: selectedCheckboxes?.filter((e) => e.key == "site")?.map((e) => e.value) || [],
            obrBu: selectedCheckboxes?.filter((e) => e.key == "obrBu")?.map((e) => e.value) || [],
            obrOrg: selectedCheckboxes?.filter((e) => e.key == "obrOrg")?.map((e) => e.value) || [],
            mainSites: selectedCheckboxes?.filter((e) => e.key == "inspectionType")?.map((e) => e.value) || [],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setQuestions(data.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchNegativeResponsesGroupwise = async () => {
    try {
      const { data } = await axios.post(
        `${configData.config.API_URL}/api/dashboard/report/negative/responses/byGroup/${groupId}`,
        {
          machineIds: machineId.map((item) => item.code),
          dates: {
            start: dates.start ? dates.start.toISOString() : null,
            end: dates.start ? dates.end.toISOString() : null,
          },
          isSite: true,
          filters: {
            site: selectedCheckboxes?.filter((e) => e.key == "site")?.map((e) => e.value) || [],
            obrBu: selectedCheckboxes?.filter((e) => e.key == "obrBu")?.map((e) => e.value) || [],
            obrOrg: selectedCheckboxes?.filter((e) => e.key == "obrOrg")?.map((e) => e.value) || [],
            mainSites: selectedCheckboxes?.filter((e) => e.key == "inspectionType")?.map((e) => e.value) || [],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setList(data.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const Reload = async () => {
    setLoading(true);

    await Promise.all([
      fetchSiteStats(),
      fetchRegionWiseResponse(),
      fetchNegativeResponses(),
      fetchNegativeResponsesGroupwise(),
      userWiseInspectionReport(),
    ]);

    setLoading(false);
  };

  const RefreshPage = async () => {
    setLoading(true);
    setUserWiseInspectionData([]);
    await Promise.all([fetchGroupDetail(), fetcSiteFilters()]);
    setMachineId([]);
    setDates({ start: null, end: null });
    Reload();
  };

  // -----------------------------------------------------NEw

  const fetchSiteStats = async () => {
    try {
      const res = await apiClient.post(`${configData.config.API_URL}${DASHBOARD_SITE_STATS}/${groupId}`, {
        dates: {
          startDate: dates.start ? dates.start.toISOString() : null,
          endDate: dates.start ? dates.end.toISOString() : null,
        },
        filters: {
          site: selectedCheckboxes?.filter((e) => e.key == "site")?.map((e) => e.value) || [],
          obrBu: selectedCheckboxes?.filter((e) => e.key == "obrBu")?.map((e) => e.value) || [],
          obrOrg: selectedCheckboxes?.filter((e) => e.key == "obrOrg")?.map((e) => e.value) || [],
          mainSites: selectedCheckboxes?.filter((e) => e.key == "inspectionType")?.map((e) => e.value) || [],
        },
      });
      setSiteStats(res);
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchRegionWiseResponse = async () => {
    try {
      const res = await apiClient.post(`${configData.config.API_URL}${FETCH_REGION_WISE_SCORE}/${groupId}`, {
        dates: {
          startDate: dates.start ? dates.start.toISOString() : null,
          endDate: dates.start ? dates.end.toISOString() : null,
        },
        filters: {
          site: selectedCheckboxes?.filter((e) => e.key == "site")?.map((e) => e.value) || [],
          obrBu: selectedCheckboxes?.filter((e) => e.key == "obrBu")?.map((e) => e.value) || [],
          obrOrg: selectedCheckboxes?.filter((e) => e.key == "obrOrg")?.map((e) => e.value) || [],
          mainSites: selectedCheckboxes?.filter((e) => e.key == "inspectionType")?.map((e) => e.value) || [],
        },
      });
      setRegionResponseStats(res);
    } catch (error) {}
  };

  const fetcSiteFilters = async () => {
    try {
      const res = await apiClient.get(`${configData.config.API_URL}${FETCH_SUB_SITE_WITH_GROUPID}/${groupId}`);
      setOptions(res);
    } catch (error) {
      console.log(error.message);
    }
  };

  const userWiseInspectionReport = async () => {
    try {
      setInspectionDataLoading(true);
      const res = await apiClient.post(`${configData.config.API_URL}${USER_WISE_INSPECTION_REPORT}/${groupId}`, {
        dates: {
          startDate: dates.start ? dates.start.toISOString() : null,
          endDate: dates.start ? dates.end.toISOString() : null,
        },
        filters: {
          site: selectedCheckboxes?.filter((e) => e.key == "site")?.map((e) => e.value) || [],
          obrBu: selectedCheckboxes?.filter((e) => e.key == "obrBu")?.map((e) => e.value) || [],
          obrOrg: selectedCheckboxes?.filter((e) => e.key == "obrOrg")?.map((e) => e.value) || [],
          mainSites: selectedCheckboxes?.filter((e) => e.key == "inspectionType")?.map((e) => e.value) || [],
        },
      });
      setUserWiseInspectionData(res);
    } catch (error) {
      console.log(error.message);
    } finally {
      setInspectionDataLoading(false);
    }
  };

  useEffect(() => {
    if (!loading) Reload();
  }, [dates]);

  useEffect(() => {
    if (!groupId.length) return;
    setActiveTab("Dashboard");
    RefreshPage();
  }, [groupId]);

  useEffect(() => {
    if (resetStateFlag) Reload();
  }, [resetStateFlag]);

  return (
    <div className="container-fluid p-0">
      <Tab.Container id="my-tabs" activeKey={activeTab} defaultActiveKey="Dashboard">
        <Nav className="tabsproduct updated toptab" variant="tabs">
          <Nav.Item>
            <Nav.Link onClick={() => setActiveTab("Dashboard")} eventKey="Dashboard">
              Site Dashboard
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link onClick={() => setActiveTab("Groups")} eventKey="Groups">
              Groups
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link onClick={() => setActiveTab("inspection_Report")} eventKey="inspection_Report">
              Site Wise Inspection Report
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <div className="container-fluid admindashboard p-4 pt-4 bg-grey-main">
          <Tab.Content className="pt-3">
            {activeTab !== "Groups" && (
              <div className="col-lg-12 d-flex align-items-center justify-content-end gap-3 pt-2">
                <DateRangeFilter
                  dates={dates}
                  setDates={(newdates) => {
                    setDates(newdates);
                  }}
                />
                <Filter
                  filterOptions={filterOptions}
                  selectedCheckboxes={selectedCheckboxes}
                  setSelectedCheckboxes={setSelectedCheckboxes}
                  clickHandler={Reload}
                  setResetStateFlag={setResetStateFlag}
                />
              </div>
            )}
            <Tab.Pane eventKey="Dashboard">
              <div className="row align-items-center mt-3 mb-2">
                <div className="col-lg-6">
                  {userData.user.group.uuid !== groupId && (
                    <button className="backbtn cursor-pointer" title="Back" onClick={() => navigate(-1)}>
                      <BackIcon />
                      Back
                    </button>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5">
                  <div className="userdash">
                    <div className="card cardesign welcomecard">
                      <div className="card-block d-flex align-items-center">
                        {loading ? (
                          <Skeleton width="70px" height="70px" circle baseColor="#ebebeb" highlightColor="#ffffff" />
                        ) : (
                          <>
                            <div className="profile-img">
                              {groupInfo?.avatar ? (
                                <img src={groupInfo?.avatar} alt="" referrerPolicy="no-referrer" />
                              ) : (
                                <div className="initials-placeholder">
                                  {groupInfo?.name ? getInitials(groupInfo?.name) : ""}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        <div className="welcomediv ps-3">
                          <h6 className="m-0 p-0">
                            {loading ? (
                              <Skeleton width="15rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                            ) : (
                              groupInfo?.name
                            )}
                          </h6>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-7">
                  <div className="userdash">
                    <div className="redgreen">
                      <span>
                        <h6>
                          {loading ? (
                            <Skeleton width="5rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                          ) : (
                            "Inspection Count"
                          )}
                        </h6>
                        <p>
                          {loading ? (
                            <Skeleton width="5rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                          ) : machineId.length ? (
                            machineId.length
                          ) : (
                            siteStats?.inspectionCount || 0
                          )}
                        </p>
                      </span>
                      <span>
                        <h6>
                          {loading ? <Skeleton width="5rem" baseColor="#ebebeb" highlightColor="#ffffff" /> : "Score"}
                        </h6>
                        <p>
                          {" "}
                          {loading ? (
                            <Skeleton width="5rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                          ) : (
                            siteStats?.score || 0
                          )}{" "}
                        </p>
                      </span>
                      <span>
                        <h6>
                          {loading ? (
                            <Skeleton width="5rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                          ) : (
                            "Finding Count"
                          )}
                        </h6>
                        <p>
                          {loading ? (
                            <Skeleton width="5rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                          ) : (
                            siteStats?.findingCount || 0
                          )}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="cardbox overflow-hidden custom-chart mt-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                      {loading ? (
                        <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                      ) : (
                        "Score By Region"
                      )}
                    </h5>
                  </div>
                  {loading ? null : <BarChart list={regionResponseStats} />}
                </div>
              </div>

              <NegativeResponses questions={questions} loading={loading} isSite={true} />

              <GroupWiseReport list={list} loading={loading} isSite={true} />
            </Tab.Pane>

            <Tab.Pane eventKey="Groups">
              <GroupList setActiveTab={setActiveTab} isSite={true} navigateLink={"/s/dashboard"} />
            </Tab.Pane>
            <Tab.Pane eventKey="inspection_Report">
              <SiteWiseInspectionReport loading={inspectionDataLoading} data={userWiseInspectionData} />
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </div>
  );
};

const getFilters = (options = []) => {
  return [
    {
      name: "Inspection Type",
      tags:
        options?.mainSites?.map((ele) => {
          return {
            name: ele?.name,
            value: ele?.uuid,
            key: "inspectionType",
          };
        }) || [],
    },
    {
      name: "Site",
      tags:
        options?.sites?.map((ele) => {
          return {
            name: ele?.name,
            value: ele?.uuid,
            key: "site",
          };
        }) || [],
    },
    {
      name: "OBR Org",
      tags:
        options?.obrOrg?.map((ele) => {
          return {
            name: ele?.name,
            value: ele?.value,
            key: "obrOrg",
          };
        }) || [],
    },
    {
      name: "OBR Bu",
      tags:
        options?.obrBu?.map((ele) => {
          return {
            name: ele?.name,
            value: ele?.value,
            key: "obrBu",
          };
        }) || [],
    },
  ];
};
export default Dashboard;
